import AreaHub from 'components/area-hub/area-hub';
import Area from 'components/area-hub/area';
import Case from 'components/area-hub/case';

const gamePagesData = {
	areaHub: {
		component: AreaHub,
		background: 'login',
		infoTitle: '!VIGTIG BESKED!',
		infoText: `Velkommen til <b>STX-uddannelsen</b> og jeres besøg på <b>%school%!</b>
			<br /><br />I er nu lige startet på STX-gymnasiet og nu skal I rundt på skolen og udforske, hvordan fag, studieliv og fremtid hænger sammen – og hvad det hele egentlig går ud på.
			<br /><br />Nu skal I undersøge, hvad <b>%school%</b> går ud på, og hvad man kan arbejde med bagefter.
			<br /><br />Jeres opgave er at træffe de bedst mulige beslutninger. I konkurrerer mod de andre hold og vinder ved at <b>svare rigtigt og undgå fejl</b>.
			<br /><br />I skal besøge hele STX-gymnasiet og både løse problemer og træffe beslutninger – I må bruge <b>alle hjælpemidler</b>, men nogle gange må I også <b>gætte jer frem</b>.
			<br /><br />I kan starte med <b>præcis dér, hvor I vil</b>. Hvert område indeholder en række udfordringer, som giver point, når I løser dem.
			<br /><br />Hvis I vil vinde, handler det ikke om at svare hurtigt – men om at svare rigtigt.
			<br />Der er nemlig et <b>begrænset antal udfordringer</b>, så tænk jer godt om: Jo færre fejl I laver, jo flere point får I.
			<br /><br />Klik rundt, løs opgaverne, indtil tiden løber ud – og se, om I kan slå de andre hold.
			<br /><br /><b>Held og lykke – og husk, at I kan følge stillingen på pointtavlen!</b>`,
		routes: [
			{
				id: 'fields',
				name: 'Studieretninger & Fag',
				pageId: 'areaFields'
			},
			{
				id: 'logic',
				name: 'Logik & Leg',
				pageId: 'areaLogic'
			},
			{
				id: 'education',
				name: 'Uddannelsesvalg & Fremtid',
				pageId: 'areaEducation'
			},
			{
				id: 'social',
				name: 'Studieliv & Fællesskab',
				pageId: 'areaSocial'
			},
			{
				id: 'teaching',
				name: 'Undervisningen & Måden vi lærer på',
				pageId: 'areaTeaching'
			}
		]
	},
	areaFields: {
		component: Area,
		caseComponent: Case,
		id: 'fields',
		name: 'Studieretninger & Fag',
		background: 'fields',
		infoTitle: 'Studieretninger & Fag',
		infoText: `Området giver en introduktion til de forskellige studieretninger og fag, man kan vælge. Her kan I udforske, hvordan fagene er sammensat, og hvad de indeholder. Gennem opgaver og information får I indsigt i, hvordan studieretninger hjælper med at forme jeres uddannelse og faglige fokus.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Kendskab til studieretninger og fag',
				pageId: null,
				text: `Her skal I tjekke spændende fakta om studieretninger og fag - og få styr på det vigtigste.`,
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Fag, som du skal have',
				pageId: null,
				text: `Velkommen til fagverdenen på STX! Her bliver I udfordret på, hvilke fag der er vigtige, hvordan niveauerne fungerer, og hvad I selv kan vælge.`,
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Studieretninger',
				pageId: null,
				text: `Valget af studieretning giver din STX en tydelig faglig retning – og det kan også få betydning for, hvilke uddannelser du kan søge bagefter. Dyk ned i det her, og se, hvor mange point I kan hente!`,
			},
			{
				id: 4,
				title: 'Udfordring 4',
				subtitle: 'Hverdagen med fag og studieretninger',
				pageId: null,
				text: `Nu går vi lidt tættere på og ser på en sjov måde, hvordan fag og studieretninger sætter præg på dagen og stemningen.`,
			},
		]
	},
	areaLogic: {
		component: Area,
		caseComponent: Case,
		id: 'logic',
		name: 'Logik & Leg',
		background: 'logic',
		infoTitle: 'Gymnasiel logik & Leg',
		infoText: `Her bliver I på en sjov måde, udfordret i jeres logiske sans, mønstergenkendelse og evne til at tænke kreativt. Her handler det ikke om faglig viden, men om at løse små, finurlige opgaver, der kræver snilde, samarbejde og et glimt i øjet. Det er sjov hjernegymnastik, der giver jer en fornemmelse af de typer af opgaver og tænkning, man ofte møder i undervisningen.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Gymnasiel logik',
				pageId: null,
				text: `Gymnasiet handler ikke kun om bøger og fag – men også om at bruge hovedet på nye måder. Logik og leg fylder mere, end man måske lige tror, og det er en sjov og vigtig del af gymnasietiden.`,
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Leg',
				pageId: null,
				text: `Selv på gymnasiet er der plads til sjov, leg og små pauser fra alt det faglige. Det giver energi og får fællesskabet til at vokse. Her kan I selv prøve kræfter med lidt leg på gymnasielt niveau.`,
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Mini-udfordringer fra fagene',
				pageId: null,
				text: `På gymnasiet venter både velkendte og helt nye fag – men på en lidt anden måde. Her får I et lille smugkig ind i nogle af fagene – korte udfordringer fra forskellige fag, hvor I kan se hvad det handler om, teste jeres viden og måske endda finde svarene på nettet.`,
			},
		]
	},
	areaEducation: {
		component: Area,
		caseComponent: Case,
		id: 'education',
		name: 'Uddannelsesvalg & Fremtid',
		background: 'education',
		infoTitle: 'Uddannelsen & Fremtiden',
		infoText: `Her får I et indblik i, hvad uddannelsen består af, og hvilke muligheder den kan føre til bagefter. Gennem opgaver og research arbejder I med fag, struktur og perspektiver – både undervejs og i forhold til videre uddannelse og fremtidige drømme. Her handler det om at forstå det samlede forløb: hvad man lærer, hvordan man udvikler sig, og hvilke døre det åbner.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Det helt basale om STX',
				pageId: null,
				text: `Her tager vi de første skridt ind i STX-verdenen. Prøv opgaver, der giver jer et hurtigt og enkelt indblik i, hvad STX handler om.`,
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Uddannelsen',
				pageId: null,
				text: `Tid til at dykke ned i, hvordan det er at gå på STX. Her får I et hurtigt indblik i, hvordan uddannelsen er bygget op, og hvad det egentlig vil sige at være en del af den.`,
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Fremtiden',
				pageId: null,
				text: `Nu ser vi på, hvad der kan ske efter gymnasiet. Der er masser af muligheder - og masser af point at hente.`,
			}
		]
	},
	areaSocial: {
		component: Area,
		caseComponent: Case,
		id: 'social',
		name: 'Studieliv & Fællesskab',
		background: 'social',
		infoTitle: 'Studieliv & Fællesskab',
		infoText: `Få et indblik i det sociale liv og fællesskabet på uddannelsen. Her kan I opleve, hvordan elever sammen skaber minder gennem fester, studieture, elevråd og fælles aktiviteter – alt det, der gør hverdagen sjovere og mere levende.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Det gode gymnasieliv',
				pageId: null,
				text: `Gymnasiet er fyldt med oplevelser, traditioner og fællesskaber, der gør hverdagen sjovere. Lad os dykke ned i alt det fede ved gymnasietiden.`
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Studieliv',
				pageId: null,
				text: `Studielivet på gymnasiet er meget mere end timer og lektier – det er også oplevelser, fællesskab og gode stunder med vennerne. Lad os se, hvad studieture, hverdagen og det, der betyder mest for jer, egentlig handler om.`
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Fællesskab',
				pageId: null,
				text: `Fællesskabet på gymnasiet gør tiden både sjovere og mere tryg. Lad os kigge på, hvordan elever hjælper hinanden, holder fast i traditionerne og skaber gode oplevelser uden for undervisningen.`
			},
		]
	},
	areaTeaching: {
		component: Area,
		caseComponent: Case,
		id: 'teaching',
		name: 'Undervisningen & Måden vi lærer på',
		background: 'teaching',
		infoTitle: 'Undervisning & Måden vi lærer på',
		infoText: `Prøv kræfter med hvordan undervisningen foregår, og hvilke arbejdsformer der bruges. Her kan I lære om projektarbejde, fremlæggelser, gruppearbejde og selvstændigt studie – og hvordan det hele hjælper jer med at blive bedre til at lære og samarbejde.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Hverdagen på STX',
				pageId: null,
				text: `På STX sker der noget hele tiden - fra undervisning og gruppearbejde til pauser, grin og gode snakke. Lad os se, hvordan en gymnasiedag egentlig ser ud i virkeligheden.`
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Undervisningen',
				pageId: null,
				text: `Undervisningen på STX er alt andet end kedelig – her skifter du mellem spændende fag, nye emner og forskellige måder at lære på. Lad os tjekke ud, hvordan det foregår i hverdagen.`
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Måden vi lærer på',
				pageId: null,
				text: `På STX lærer du på mange forskellige måder – nogle gange med hele klassen, andre gange i grupper eller på egen hånd. Lad os se nærmere på, hvordan undervisningen bliver varieret og spændende.`
			}
		]
	},
};

export {
	gamePagesData,
};